import { Container, Col } from "react-bootstrap";
import SectionHeading from "../ui/SectionHeading";
import { RevealGroup, RevealItem } from "../ui/Reveal";
import "../style/OurStory.css";

const OFFERINGS = ["Idly Batter", "Dosa Batter", "Ragi Batter", "Multi-grain Batter"];

const OurStory = () => {
  return (
    <>
      <section className="section-pad our-story">
        <Container className="container-narrow">
          <RevealGroup className="row g-4 our-story__row">
            <Col md={6}>
              <RevealItem className="our-story__art">
                <img
                  src="/images/familyStory.jpeg"
                  alt="The Bit Byte Foods founding team"
                  className="our-story__img"
                />
              </RevealItem>
            </Col>
            <Col md={6} className="d-flex align-items-center">
              <RevealItem delay={80} className="our-story__copy">
                <span className="eyebrow">Our History</span>
                <h2>From a College Gang to a Family Business</h2>
                <p>
                  On November 6th, 2022, we started selling our authentic,
                  all-natural Idly and Dosa Batter. Alongside it, we launched
                  Idly Dosa Camp (now renamed Kote Cafe) as a QSR — the idea was simple: if customers
                  were unsure about our batter, we invited them to visit and
                  taste fresh idlis and dosas made from it themselves.
                </p>
                <p>
                  It let people experience the taste and quality firsthand
                  before buying a pack, and it meant our own camp acted as a
                  B2B outlet for our batter, so nothing went to waste.
                </p>
                <p>
                  From a college gang to a startup, our journey is built on
                  friendship, passion, and a love for quality food — and
                  this is just the beginning.
                </p>
              </RevealItem>
            </Col>
          </RevealGroup>

          <RevealGroup className="row g-4 our-story__row our-story__row--reverse">
            <Col md={6} className="d-flex align-items-center order-md-1">
              <RevealItem delay={80} className="our-story__copy">
                <span className="eyebrow">Tradition &amp; Quality</span>
                <h2>A Blend of Tradition &amp; Quality</h2>
                <p>
                  We believe great food starts with great ingredients.
                  That&apos;s why all our raw materials are sourced locally,
                  and we use only RO water for a fresh, authentic taste.
                </p>
                <p>
                  Staying true to tradition, our single stone grinders slowly
                  and carefully grind the batter, preserving its natural
                  texture and flavor — because just like the finest blooms,
                  good food takes time.
                </p>
                <p>
                  Our batters are packed in food-grade, ziplock-sealed
                  pouches, ensuring freshness and convenience for our
                  customers.
                </p>
                <p>
                  What began as a small college-gang venture has grown
                  steadily over the past few years into a trusted name
                  across North Karnataka. Today, our batter is also
                  available on Blinkit, delivering the same fresh,
                  stone-ground quality to doorsteps in major cities across
                  the region.
                </p>
              </RevealItem>
            </Col>
            <Col md={6} className="order-md-2">
              <RevealItem className="our-story__art">
                <img
                  src="/images/MomStory.jpeg"
                  alt="Batter made the way mom used to make it"
                  className="our-story__img"
                />
              </RevealItem>
            </Col>
          </RevealGroup>
        </Container>
      </section>

      <section className="section-pad our-story__offerings">
        <Container className="container-narrow">
          <SectionHeading eyebrow="What We Make" title="Our Current Offerings" />
          <RevealGroup className="row g-3 justify-content-center">
            {OFFERINGS.map((item, i) => (
              <Col xs={6} sm={3} key={item}>
                <RevealItem
                  delay={i * 80}
                  className="our-story__offering card-surface"
                >
                  {item}
                </RevealItem>
              </Col>
            ))}
          </RevealGroup>
        </Container>
      </section>
    </>
  );
};

export default OurStory;
